import { render, staticRenderFns } from "./LotteryPanel.vue?vue&type=template&id=edb195bc&scoped=true"
import script from "./LotteryPanel.vue?vue&type=script&lang=js"
export * from "./LotteryPanel.vue?vue&type=script&lang=js"
import style0 from "./LotteryPanel.vue?vue&type=style&index=0&id=edb195bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb195bc",
  null
  
)

export default component.exports